import SettingManagement from "./setting-management.page";

export default SettingManagement;
